exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".SaveDetalizationPopup_title_3ENG {\n  margin-bottom: 20px;\n}\n\n.SaveDetalizationPopup_subtitle_1syj {\n  margin-bottom: 20px;\n}\n\n.SaveDetalizationPopup_preloader_3KUV {\n  position: static;\n\n  -webkit-transform: none;\n\n          transform: none;\n}\n", ""]);

// exports
exports.locals = {
	"title": "SaveDetalizationPopup_title_3ENG",
	"subtitle": "SaveDetalizationPopup_subtitle_1syj",
	"preloader": "SaveDetalizationPopup_preloader_3KUV"
};